const initialState = {
  allApiAlerts: [],
  prodSpecificApiAlerts: [],
  createProdSpecificApiAlerts: [],
  updateProdSpecificApiAlerts: []
};

const ApiAlertsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_API_ALERTS':
      return { ...state, allApiAlerts: action.payload };
    case 'GET_PROD_SPECIFIC_API_ALERTS':
      return { ...state, prodSpecificApiAlerts: action.payload };
    case 'CREATE_PROD_SPECIFIC_API_ALERTS':
      return { ...state, createSpecificApiAlerts: action.payload };
    case 'UPDATE_PROD_SPECIFIC_API_ALERTS':
      return { ...state, updateSpecificApiAlerts: action.payload };
    default:
      return state;
  }
};

export default ApiAlertsReducer;
